import { render, staticRenderFns } from "./MarketSettingArea.vue?vue&type=template&id=4ab7787e"
import script from "./MarketSettingArea.vue?vue&type=script&lang=js"
export * from "./MarketSettingArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports